<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { ProductDialog } from '@/types/api/api-v3/product'

/* Components */
const ProductDialogContent = defineAsyncComponent(
  () => import('@/components/Product/ProductDialogContent.vue'),
)

const props = defineProps({
  productDialog: {
    type: Object as PropType<ProductDialog>,
    required: true,
  },
})

const emit = defineEmits(['closeDialogProduct'])

const { isMobile } = useDevice()

const closeDialogProduct = () => {
  emit('closeDialogProduct')
}
</script>

<template>
  <client-only>
    <v-dialog
      v-if="props.productDialog.visible && props.productDialog.currentProduct"
      v-bind="$attrs"
      ref="dialog"
      :model-value="props.productDialog.visible"
      :max-width="'794'"
      :fullscreen="isMobile"
      @update:model-value="closeDialogProduct"
      @keydown.esc="closeDialogProduct"
    >
      <product-dialog-content
        :product="props.productDialog.currentProduct"
        :products="props.productDialog.productList"
        @close-dialog-product="closeDialogProduct"
      />
    </v-dialog>
  </client-only>
</template>
